import React from 'react';

import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';

function DataModel() {
  return (
    <div className="row">
      <div className="w-100">
        <p>
          We selected two biological models for our experiments.
          The first, <strong>degrade and fire</strong> oscillations caused by small time delays in regulatory networks, exhibits variability in the period between activations.
          The second, <strong>an ultradian model</strong> with delta kicks, utilizes a delay-induced chaotic regime of the insulin-glucose cycle.
        </p>
      </div>
      <h5>Degrade and Fire Oscillation</h5>
      <div className="w-100">
        <p>
          We utilize a constructed synthetic gene oscillator for our degrade-and-fire model.
          The mass-action kinetics of our delayed production and degradation is expressed by the delay-differential equation
        </p>
      </div>
      <div className="w-100">
        <BlockMath>{` \\small \\dot r = \\frac{\\alpha C^{2}_{0}}{(C_{0}+r_{\\tau})} - \\frac{\\gamma_{r}r(t)}{R_{0}+r(t)} - \\beta r(t) `}</BlockMath>
      </div>
      <h5>Insulin-Glucose Cycle</h5>
      <div className="w-100">
        <p>We expand the <strong>Ultradian model</strong> for glucose-insulin production with <strong>delta kicks</strong> for our chaotic series.</p>
      </div>
      <div className="w-100">
        <BlockMath>
          {`
            \\begin{aligned}
            \\footnotesize \\frac{\\text{d}I_{p}}{\\text{d}t} &= f_{1}(G) - E \\left( \\frac{I_{p}}{V_{p}} - \\frac{I_{i}}{V_{i}} \\right) - \\frac{I_{p}}{t_{p}} \\\\
            \\footnotesize \\frac{\\text{d}I_{i}}{\\text{d}t} &= E \\left( \\frac{I_{p}}{V_{p}} - \\frac{I_{i}}{V_{i}} \\right) - \\frac{I_{i}}{t_{i}} \\\\
            \\footnotesize \\frac{\\text{d}G}{\\text{d}t} &= f_{4}(h_{3}) + I_{G}(t) - f_{2}(G) - f_{3}(I_{i})G \\\\
            \\footnotesize \\frac{\\text{d}h_{1}}{\\text{d}t} &= \\frac{1}{t_{d}}(I_{p}-h_{1}) \\\\
            \\footnotesize \\frac{\\text{d}h_{2}}{\\text{d}t} &= \\frac{1}{t_{d}}(h_{1}-h_{2}) \\\\
            \\footnotesize \\frac{\\text{d}h_{3}}{\\text{d}t} &= \\frac{1}{t_{d}}(h_{2}-h_{3})
            \\end{aligned}
          `}
        </BlockMath>
      </div>
      <div className="w-100">
        <p>Our nutritional driver <InlineMath>{` I_{G}(t) `}</InlineMath> includes basal signal and pulsatile kicks</p>
      </div>
      <div className="w-100">
        <BlockMath>{` I_{G}(t) = I_{0} + \\displaystyle \\sum_{n=0}^{\\infty}A_{n}\\delta(t-T_{n}) `}</BlockMath>
      </div>
    </div>
  );
}

export default DataModel;
